import {useEffect} from 'react'
import {useDispatch} from 'react-redux'
import {setEnabledBrands} from '../modules/slice'
import {EnabledBrands} from '../../brand/types'

interface PropTypes {
  enabledBrands: EnabledBrands[]
}

export const SyncStateWithEnabledBrands = ({enabledBrands}: PropTypes) => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(setEnabledBrands(enabledBrands))
  }, [dispatch, enabledBrands])

  return null
}
